import React from 'react';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import { styled } from '@mui/system';
import { useResponsive } from '../../contexts/ResponsiveContext';
import { AboutInvestorRelationsOverviewAnalystCoverageContent } from '../../graphql/pimcore/modules/siteContent/types/AboutInvestorRelationsContent';

interface AnalystCoverageTableProps {
    cmsContent: AboutInvestorRelationsOverviewAnalystCoverageContent;
}

const AnalystCoverageTable = ({ cmsContent }: AnalystCoverageTableProps) => {
    const { isScreenSm, isScreenXs } = useResponsive();

    const headers: string[] = cmsContent.table.tableHeader;
    const rows: string[][] = cmsContent.table.tableBody;
    const referenceDate: string = cmsContent.referenceDate.content;

    const StyledHeaderCell = styled(TableCell)(() => ({
        backgroundColor: '#B95B3B',
        color: 'white',
        fontWeight: 500,
        fontSize: '12px',
        textAlign: 'center',
        fontFamily: 'Poppins',
    }));

    const cellSx = {
        fontWeight: 500,
        fontSize: '12px',
        fontFamily: 'Poppins',
    };

    const StyledTableRow = styled(TableRow)(() => ({
        '&:nth-of-type(odd)': {
            backgroundColor: '#F2F2F2',
        },
    }));

    return (
        <Box marginTop="1rem" marginBottom="0.2rem">
            <TableContainer
                component={Paper}
                sx={{
                    maxWidth: 1000,
                    margin: '0 auto',
                    borderRadius: '0px',
                    overflow: isScreenSm || isScreenXs ? 'auto' : 'hidden',
                }}
            >
                <Table>
                    <TableHead>
                        <TableRow>
                            {headers.map((header, idx) => (
                                <StyledHeaderCell key={idx}>
                                    {header.split('\n').map((line, index, arr) => (
                                        <React.Fragment key={index}>
                                            {line}
                                            {index < arr.length - 1 && <br />}
                                        </React.Fragment>
                                    ))}
                                </StyledHeaderCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, rowIdx) => (
                            <StyledTableRow key={rowIdx}>
                                {row.map((cell, cellIdx) => (
                                    <TableCell
                                        key={cellIdx}
                                        sx={{ ...cellSx, textAlign: 'center' }}
                                    >
                                        {cell}
                                    </TableCell>
                                ))}
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box sx={{ ...cellSx, textAlign: 'right' }}>{referenceDate}</Box>
        </Box>
    );
};

export default AnalystCoverageTable;
